var render, staticRenderFns
import script from "./control-table-view.vue?vue&type=script&lang=js"
export * from "./control-table-view.vue?vue&type=script&lang=js"
import style0 from "./control-table-view.vue?vue&type=style&index=0&id=00f6c428&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f6c428",
  null
  
)

export default component.exports